import angular from 'angular';
import controller from './qty.controller';
import template from './qty.html';
import './qty.scss';
import QtyComponent from './qty.component';

const qtyConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('qty', {
		title:                      'Quantity',
		template,
		children:                   false,
		group:                      'advanced',
		selectable:                 true,
		settings:                   new QtyComponent(),
		icon:                       'fa fa-thermometer-half',
		views:                      [
			{
				name:     'Display',
				template: 'kform/components/qty/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/qty/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/qty/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		onEdit: /* @ngInject */     (/** @type {any} */ $scope) => {
			$scope.$watch('component.defaultValue', () => {
				for (const index in $scope.data[$scope.component.key]) {
					$scope.data[$scope.component.key][index] = {
						qty:  $scope.component.defaultValue.qty,
						unit: $scope.component.defaultValue.unit,
					};
				}
			}, true);
		},
		controller,
	});
};

export default angular.module('app')
	.config(qtyConfig);
